module.exports = __webpack_public_path__ + "img/bridgit.6092c1b7.svg";